import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette, breakpoints }) => ({
    close_drawer_button: {
        backgroundColor: `${palette.primary.main}10`,
        height: "100%",
        width: 25,
    },
    close_drawer_button__icon: {
        bottom: "48vh",
        position: "fixed",
    },
    drawer: {
        background: palette.common.white,
        height: "100%",
        right: 0,
        zIndex: 999,
        marginLeft: -50,
    },
    "drawer--active": {
        boxShadow: "-10px 0px 15px 0px rgba(34, 60, 80, 0.2)",
        maxWidth: 525,
        width: "100%",
    },
    "drawer--inactive": {
        display: "none",
        position: "fixed",
    },
    "drawer--absolute": {
        position: "absolute",
        marginLeft: 0,
    },
    drawer__inn: {
        height: "100%",
        overflow: "hidden",
    },
    drawer__inn__content: {
        flexGrow: 1,
        overflow: "auto",
    },
    open_drawer_button: {
        alignItems: "center",
        background: "white",
        borderLeft: `1px solid ${palette.divider}`,
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        width: 50,
        [breakpoints.down("sm")]: {
            width: 30,
        },
    },
    open_drawer_button__text: {
        color: palette.primary.main,
        transform: "rotate(180deg)",
        writingMode: "vertical-lr",
        whiteSpace: "nowrap",
    },
}));
//# sourceMappingURL=ui_sidebar.css.js.map